<template>
	<div id="box" style="overflow-x: hidden;overflow-y: hidden;">
		<navbar></navbar>
		<div v-bind:class="{content2:changeWidth,content:changeWidth1}">
			<div style="width: 100%;">
				<center>
					<h1 style="font-size: 1.75rem;padding-top: 1.25rem;">{{$t('calc.title')}}</h1>
				</center>
			</div>
			<el-divider></el-divider>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
					<center>
						<div class="grid-content">
							<el-form :inline="true" :label-position="labelPosition" :model="calcForm"
								class="demo-form-inline">


								<el-form-item :label="$t('calc.kw')">
									<el-input :placeholder="$t('calc.input_kw')" v-model="calcForm.gl">
										<span slot="append" style="width: 4.375rem;">W</span>
									</el-input>
								</el-form-item>
								<el-form-item :label="$t('calc.df')">
									<el-input :placeholder="$t('calc.input_df')" v-model="calcForm.dj">
										<span slot="append" style="width: 4.375rem;">￥</span>
									</el-input>
								</el-form-item>
								<el-form-item :label="$t('calc.yjcb')">
									<el-input :placeholder="$t('calc.input_cb')" v-model="calcForm.cb">
										<span slot="append" style="width: 4.375rem;">￥</span>
									</el-input>
								</el-form-item>
								<el-form-item :label="$t('calc.kccs')">
									<el-input :placeholder="$t('calc.input_csbl')" v-model="calcForm.cs">
										<span slot="append" style="width: 4.375rem;">%</span>
									</el-input>
								</el-form-item>
								<el-form-item :label="$t('calc.dqbj')">
									<el-input :placeholder="$t('calc.input_dqbj')" v-model="calcForm.bj">
										<span slot="append" style="width: 4.375rem;">￥</span>
									</el-input>
								</el-form-item>
								<el-form-item :label="$t('calc.kjsl')">
									<el-input :placeholder="$t('calc.input_sl')" v-model="calcForm.hashrate">
										<el-select v-model="calcForm.unit" slot="append" placeholder="请选择"
											style="width: 4.375rem;">
											<el-option label="H" value="H"></el-option>
											<el-option label="KH" selected value="KH"></el-option>
											<el-option label="MH" value="MH"></el-option>
											<el-option label="GH" value="GH"></el-option>
											<el-option label="TH" value="TH"></el-option>
										</el-select>
									</el-input>
								</el-form-item>
								<br />
								<el-form-item>
									<el-button type="primary" @click="onSubmit">{{$t('calc.buttontitle')}}</el-button>
									<!-- <el-button>取消</el-button> -->
								</el-form-item>
							</el-form>

						</div>

					</center>
				</el-col>

				<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
					<center>
						<div class="grid-content">
							<el-row :gutter="10" id="info-head">
								<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
									<div class="box-card">
										<span>{{$t('calc.hbsj')}}</span>
										<p id="hbsj">{{head.hbsj}}</p>
									</div>
								</el-col>
								<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
									<div class="box-card">
										<span>{{$t('calc.nethash')}}</span>
										<p id="neiwork">{{head.networkhash}}</p>
									</div>
								</el-col>
								<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
									<div class="box-card">
										<span>{{$t('calc.netdiff')}}</span>
										<p>{{head.diff}}</p>
									</div>
								</el-col>
								<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
									<div class="box-card">
										<span>{{$t('calc.gjbj')}}</span>
										<p>{{head.gjbj}}</p>
									</div>
								</el-col>
							</el-row>
							<el-row id="info-day">
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item item-head">
										<p>
											<span>
												{{dayincome.jly}}
											</span>
										</p>
										<small class="item-head-desc">{{$t('calc.mrjsy')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{dayincome.xmrincome}}
											</span>
										</p>
										<small class="item-info-desc">XMR/{{$t('calc.r')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{dayincome.shouyi}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mrcz')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{dayincome.power}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mryd')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{dayincome.powerout}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mrdf')}}</small>
									</div>
								</el-col>
							</el-row>

							<el-row id="info-week">
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item item-head">
										<p>
											<span>
												{{weekincome.jly}}
											</span>
										</p>
										<small class="item-head-desc">{{$t('calc.mzjsy')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{weekincome.xmrincome}}
											</span>
										</p>
										<small class="item-info-desc">XMR/{{$t('calc.z')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{weekincome.shouyi}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mzcz')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{weekincome.power}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mzyd')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{weekincome.powerout}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mzdf')}}</small>
									</div>
								</el-col>
							</el-row>

							<el-row id="info-month">
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item item-head">
										<p>
											<span>
												{{monthincome.jly}}
											</span>
										</p>
										<small class="item-head-desc">{{$t('calc.myjsy')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{monthincome.xmrincome}}
											</span>
										</p>
										<small class="item-info-desc">XMR/{{$t('calc.y')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{monthincome.shouyi}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mycz')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{monthincome.power}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.myyd')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{monthincome.powerout}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mydf')}}</small>
									</div>
								</el-col>
							</el-row>
							<el-row id="info-year">
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item item-head">
										<p>
											<span>
												{{yearincome.jly}}
											</span>
										</p>
										<small class="item-head-desc">{{$t('calc.mnjsy')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{yearincome.xmrincome}}
											</span>
										</p>
										<small class="item-info-desc">XMR/{{$t('calc.n')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{yearincome.shouyi}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mncz')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{yearincome.power}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mnyd')}}</small>
									</div>
								</el-col>
								<el-col :xs="{span: '4-8'}" :sm="{span: '4-8'}" :md="{span: '4-8'}" :lg="{span: '4-8'}"
									:xl="{span: '4-8'}">
									<div class="item">
										<p>
											<span class="item-info">
												{{yearincome.powerout}}
											</span>
										</p>
										<small class="item-info-desc">{{$t('calc.mndf')}}</small>
									</div>
								</el-col>
							</el-row>
						</div>


					</center>
				</el-col>
			</el-row>
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	import navbar from '../../toolbar/navbar.vue'
	var axios = require('axios');
	import footerbar from '../../toolbar/footer.vue'
	export default {
		components: {
			navbar,
			footerbar
		},
		data() {
			return {
				labelPosition: 'right',
				networkstat: {},
				poolstat: {},
				outputcny: '',
				outputusd: '',
				calcForm: {
					hashrate: 1,
					unit: 'KH',
					gl: 1000,
					dj: 0.3,
					cb: 0,
					cs: 0,
					bj: 0,
				},
				head: {
					hbsj: '0 天',
					networkhash: '0 H/s',
					diff: '0 H',
					gjbj: '0 CNY'
				},
				dayincome: {
					jly: '0 天',
					xmrincome: '0',
					shouyi: '0',
					power: '0',
					powerout: '0'
				},
				weekincome: {
					jly: '0',
					xmrincome: '0 ',
					shouyi: '0 ',
					power: '0 ',
					powerout: '0'
				},
				monthincome: {
					jly: '0 ',
					xmrincome: '0 ',
					shouyi: '0 ',
					power: '0 ',
					powerout: '0'
				},
				yearincome: {
					jly: '0',
					xmrincome: '0',
					shouyi: '0 ',
					power: '0 ',
					powerout: '0'
				},
				L: { //Localization
					perc: '9 %',
					thou: ',',
					dec: '.',
					tme: 'G:i'
				},
				hashconv: {
					TH: 1000000000000,
					GH: 1000000000,
					MH: 1000000,
					KH: 1000,
					H: 1
				},
				screenWidth: document.documentElement.clientWidth, //屏幕宽度
				changeWidth: false,
				changeWidth1: true,


			}
		},
		watch: {
			'screenWidth': function(val) { //监听屏幕宽度变化
				var oIframe = document.getElementById("#box");

				if (Number(val) <= 750) {
					this.changeWidth = true
					this.changeWidth1 = false
				} else if (Number(val) >= 750) {
					this.changeWidth = false
					this.changeWidth1 = true
				}
				// oIframe.style.width = (Number(val)-120) + 'px'; //'120'是页面布局调整，可去除

			},
		},

		async mounted() {
			let that = this
			window.onresize = function() { // 定义窗口大小变更通知事件
				that.screenWidth = document.documentElement.clientWidth; //窗口宽度
			};
			var poolstatconfig = {
				method: 'get',
				url: 'https://api.c3pool.com/pool/stats',
				headers: {}
			};
			await axios(poolstatconfig)
				.then(function(response) {
					that.poolstat = response.data
					that.calcForm.bj = response.data.pool_statistics.price.cny.toFixed(2)
					// console.log(that.calcForm.bj)
					// console.log(JSON.stringify(response.data));
				})
				.catch(function(error) {
					console.log(error);
				});
			var networkstatconfig = {
				method: 'get',
				url: 'https://api.c3pool.com/network/stats',
				headers: {}
			};

			await axios(networkstatconfig)
				.then(function(response) {
					that.networkstat = response.data

					if (response.data.difficulty != undefined || response.data.difficulty != null) {
						that.head.networkhash = that.HashConvStr(response.data.difficulty / 120)
						that.head.diff = that.HashConvStr2(response.data.difficulty)
					}

					// console.log(JSON.stringify(response.data));
				}).catch(function(error) {

					console.log(error);
				});
			this.onSubmit()
		},
		methods: {
			HashConv(h) {
				h = (h > 0) ? h : 0;
				var u = '/s';
				for (var k in this.hashconv) {
					if (h >= this.hashconv[k]) {
						h = h / this.hashconv[k];
						u = k + u;
						break;
					}
				}
				if (h === 0) u = 'H/s'
				return {
					'num': this.Rnd(h, 2),
					'unit': u
				};
			},
			HashConv2(h) {
				h = (h > 0) ? h : 0;
				var u = '';
				for (var k in this.hashconv) {
					if (h >= this.hashconv[k]) {
						h = h / this.hashconv[k];
						u = k + u;
						break;
					}
				}
				if (h === 0) u = 'H/s'
				return {
					'num': this.Rnd(h, 2),
					'unit': u
				};
			},
			HashConvStr(h, unit) {
				var h = this.HashConv(h);
				return h.num + ' ' + (unit ? h.unit.replace(/H\//, unit + '/') : h.unit);
			},

			HashConvStr2(h, unit) {
				var h = this.HashConv2(h);
				return h.num + ' ' + (unit ? h.unit.replace(/H\//, unit + '/') : h.unit);
			},
			Rnd(n, dec, m) {
				if (dec >= 1) {
					var d = Math.pow(10, dec);
					n = Math.round(n * d) / d;
					if (m === 'txt') {
						n = n.toFixed(dec);
						if (this.L.dec !== '.') n = n.replace('.', this.L.dec);
					}
				} else {
					n = Math.round(n);
				}
				return n;
			},
			onSubmit() {
				var hash = this.calcForm.hashrate //?this.calcForm.hashrate>0:0
				if ("KH" === this.calcForm.unit) {
					hash = hash * 1000
				} else if ("MH" === this.calcForm.unit) {
					hash = hash * 1000000
				} else if ("GH" === this.calcForm.unit) {
					hash = hash * 1000000000
				} else if ("TH" === this.calcForm.unit) {
					hash = hash * 1000000000000
				}
				var df = this.calcForm.gl / 1000 * 24 * this.calcForm.dj
				var sy = (100 - this.calcForm.cs) / 100 * this.calc(hash, 1) //计算人民币收益
				var sy2 = (100 - this.calcForm.cs) / 100 * this.calc(hash, 4) //计算关机币价
				// console.log(hash, sy, df.toFixed(2), (100 - this.calcForm.cs) / 100, df / sy2)

				//回本时间
				var hbsj = (this.calcForm.cb / sy).toFixed(2)
				// console.log("hbsj：" + hbsj)
				if (hbsj > 0) {
					this.head.hbsj = hbsj + ' 天'
				} else if (hbsj === 0.00) {
					this.head.hbsj = '0 天'
				} else {
					this.head.hbsj = '无法回本'
				}
				//关机币价
				this.head.gjbj = (df / sy2).toFixed(2) + " CNY"
				//一天的行内容
				this.dayincome.power = (this.calcForm.gl / 1000 * 24).toFixed(2) + " 度"
				this.dayincome.powerout = ((this.calcForm.gl / 1000 * 24).toFixed(2) * this.calcForm.dj).toFixed(2) + " CNY"
				this.dayincome.xmrincome = ((100 - this.calcForm.cs) / 100 * this.calc(hash, 4)).toFixed(6)
				this.dayincome.shouyi = ((100 - this.calcForm.cs) / 100 * this.calc(hash, 1)).toFixed(2) + " CNY"
				this.dayincome.jly = ((100 - this.calcForm.cs) / 100 * this.calc(hash, 1) - (this.calcForm.gl / 1000 * 24)
					.toFixed(2) * this.calcForm.dj).toFixed(2) + " CNY"

				this.weekincome.power = ((this.calcForm.gl / 1000 * 24).toFixed(2) * 7).toFixed(2) + " 度"
				this.weekincome.powerout = (((this.calcForm.gl / 1000 * 24).toFixed(2) * this.calcForm.dj).toFixed(2) * 7)
					.toFixed(2) +
					" CNY"
				this.weekincome.xmrincome = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 4)).toFixed(6) * 7).toFixed(
					6)
				this.weekincome.shouyi = ((((100 - this.calcForm.cs) / 100 * this.calc(hash, 1)).toFixed(2)) * 100 / 100 *
					7 ).toFixed(2)+" CNY"
				this.weekincome.jly = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 1) - (this.calcForm.gl / 1000 *
						24)
					.toFixed(2) * this.calcForm.dj).toFixed(2) * 7).toFixed(2) + " CNY"

				this.monthincome.power = ((this.calcForm.gl / 1000 * 24).toFixed(2) * 30).toFixed(2) + " 度"
				this.monthincome.powerout = (((this.calcForm.gl / 1000 * 24).toFixed(2) * this.calcForm.dj).toFixed(2) *
					30).toFixed(2) + " CNY"
				this.monthincome.xmrincome = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 4)).toFixed(6) * 30)
					.toFixed(6)
				this.monthincome.shouyi = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 1)).toFixed(2) * 30).toFixed(
					2) + " CNY"
				this.monthincome.jly = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 1) - (this.calcForm.gl / 1000 *
					24).toFixed(2) * this.calcForm.dj).toFixed(2) * 30).toFixed(2) + " CNY"

				this.yearincome.power = ((this.calcForm.gl / 1000 * 24).toFixed(2) * 365).toFixed(2) + " 度"
				this.yearincome.powerout = (((this.calcForm.gl / 1000 * 24).toFixed(2) * this.calcForm.dj).toFixed(2) *
					365).toFixed(2) + " CNY"
				this.yearincome.xmrincome = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 4)).toFixed(6) * 365)
					.toFixed(6)
				this.yearincome.shouyi = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 1)).toFixed(2) * 365).toFixed(
					2) + " CNY"
				this.yearincome.jly = (((100 - this.calcForm.cs) / 100 * this.calc(hash, 1) - (this.calcForm.gl / 1000 *
						24)
					.toFixed(2) * this.calcForm.dj).toFixed(2) * 365).toFixed(2) + " CNY"
				// console.log(this.dayincome)
				// console.log(this.weekincome)
			},
			otherContent() {

			},
			difficultyToHashRate(hashrate) {
				return Math.floor(hashrate / 120);
			},
			calc(hash, type) {
				var money = 0;
				if (type === 1) {
					money = this.poolstat.pool_statistics.price.cny
				} else if (type === 2) {
					money = this.poolstat.pool_statistics.price.usd
				} else if (type === 3) {
					money = this.poolstat.pool_statistics.price.eur
				} else if (type === 4) {
					money = 1
				}
				// console.log((hash / this.difficultyToHashRate(this.networkstat.difficulty) * (24 * 60 * 60) / 120 * this
				// 	.poolstat.pool_statistics.minBlockRewards[18081]).toFixed(10))
				return (hash / this.difficultyToHashRate(this.networkstat.difficulty) * (24 * 60 * 60) / 120 * this
					.poolstat.pool_statistics.minBlockRewards[18081] *
					money)
			}
		}
	}
</script>

<style scoped>
	.item {
		/* background-color: #000000; */
		/* border-radius: 0.3125rem; */
		/* border-top: 1px solid #eee; */
		/*  border-left: 1px solid #eee;
		    border-bottom: 1px solid #eee; */

		padding: 13px 10px;
		border: 1px solid #dee2e6 !important;
	}

	.item-head {
		background: #677df8;
	}

	.item-head span {
		font-size: 1.25rem;
		font-weight: 500;
		line-height: 1.2;
		color: white;
		/* background: #677df8; */
	}

	.item-info {
		font-size: 1.25rem;
		font-weight: 500;
		line-height: 1.2;
		color: #007bff !important
	}

	.item-head-desc {
		color: white;
		font-weight: 400;
	}

	.item-info-desc {
		/* color: white; */
		font-weight: 400;
	}

	.small,
	small {

		font-size: 80%;
		font-weight: 400;
	}

	#info-day {
		width: 95%;
		margin-top: 0.9375rem;
		padding-left: 5px;
		padding-right: 5px;
	}

	#info-week {
		width: 95%;
		margin-top: 0.9375rem;
		padding-left: 5px;
		padding-right: 5px;
	}

	#info-month {
		width: 95%;
		margin-top: 0.9375rem;
		padding-left: 5px;
		padding-right: 5px;
	}

	#info-year {
		width: 95%;
		margin-top: 0.9375rem;
		padding-left: 5px;
		padding-right: 5px;
	}

	#info-head {
		width: 95%;
	}

	.el-col-xs-4-8 {
		/* font-weight: 500;
		    line-height: 1.2; */
		text-align: right !important;
		width: 20%;
	}

	.el-col-sm-4-8 {
		text-align: right !important;
		width: 20%;
	}

	.el-col-md-4-8 {
		text-align: right !important;
		width: 20%;
	}

	.el-col-lg-4-8 {
		text-align: right !important;
		width: 20%;
	}

	.el-col-xl-4-8 {
		text-align: right !important;
		width: 20%;
	}

	.box-card {
		padding: 0;
		flex: 1;
		padding: 10px 10px;
		color: #fff;
		text-align: right;
		border-radius: 2px;
		line-height: 35px;
		background: #677df8;
		/* border-left: 3px solid #5469db; */

	}

	.box-card span {

		padding: 5px 10px;
		font-size: 12px;
		border-radius: 12px;
		background: #FFF;
		color: #1335f6;
	}

	.box-card p {
		color: white;
		font-size: 18px;

	}

	.content {
		background-color: white;
		width: 70%;
		margin: auto;
		margin-top: 5rem;
		padding-bottom: 2.5rem;
		margin-bottom: 5rem;
		border-radius: 0.5rem;
		box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
		-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
	}

	.content2 {
		background-color: white;
		width: 90%;
		margin: auto;
		margin-top: 5rem;
		padding-bottom: 2.5rem;
		margin-bottom: 5rem;
		border-radius: 0.5rem;
		box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
		-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
	}

	#box {
		background-color: #F8FAFF;
	}

	.grid-content {
		border-radius: 0.3125rem;

	}

	.el-card__body {
		padding: 0px;
	}

	.demo-form-inline {
		/* background-color: #F8FAFF; */
		padding-top: 1.875rem;
		width: 80%;
		border-radius: 0.3125rem;
		border: 1px solid #dee2e6 !important;
	}
</style>
